import React from "react";
import { Badge } from "@chakra-ui/react";

const CORES_POR_LABEL = {
  Inclusão: "#169499",
  Alteração: "#B9690D",
  Exclusão: "#A73737",
};

export default function AcaoAuditoriaBadge({ acao }) {
  const bg = CORES_POR_LABEL[acao] || "#5F6377";

  return (
    <Badge
      backgroundColor={bg}
      color="#FFF"
      borderRadius="20px"
      px="10px"
      py="3px"
      fontWeight={600}
      fontSize="12px"
      textTransform="none"
    >
      {acao}
    </Badge>
  );
}
